import { InputLabel } from "./input-label";
import { MaskInputLabel } from "./mask-input-label";
import { TextAreaLabel } from "./text-area-label";
import { InputFormLabel } from "./input-form";
import { Select } from "./input-select";
import { RadioButtonGroupForm } from "./radio-button-group";
import { InputPassword } from "./input-password";
import { Toggle } from "./toggle";
import { InputDatePicker } from "./input-date/date-picker";
import { LocalizationProviderCustom } from "./input-date/provider";

export const Input = {
  Label: InputLabel,
  Password: InputPassword,
  TextAreaLabel: TextAreaLabel,
  Masked: MaskInputLabel,
  Select: Select,
  FormLabel: InputFormLabel,
  FormRadio: RadioButtonGroupForm,
  Toggle: Toggle,
  DatePicker: InputDatePicker,
  DateProvider: LocalizationProviderCustom
};
